import React, { FC } from 'react'
import { InfoSVGIcon } from '@/components/icons'
import { ErrorItem } from '@/types/error-response'

type CalloutProps = {
  title: string;
  smallCaption: string;
  isError?: boolean;
  isFloating?: boolean;
  hasIcon?: boolean;
  errorItems?: ErrorItem[];
};

const Callout: FC<CalloutProps> = props => {
  const {
    title,
    smallCaption,
    isError = false,
    isFloating = false,
    hasIcon = true,
    errorItems = [],
  } = props

  const hasErrorItems = errorItems && errorItems.length > 0

  // `[&.info-error]:` (0-2-0, variant band) overrides the border colour and
  // background below; a plain utility would only tie them.
  return (
    <div
      className={`large-callout flex items-center gap-4 rounded-xl [border:1px_solid_var(--gray-5)] bg-gray-6 p-4 [&_.info-svg_path]:stroke-gray-3 [&_.info-svg_path]:[stroke-opacity:1] [&.info-error_.info-svg_path]:[stroke:#e4635c] [&.info-error]:[border-color:#e4635c] [&.info-error]:[background-color:var(--opaque-danger-light)] ${isError ? 'info-error' : ''} ${
        isFloating ? 'floating absolute bottom-[24px] w-[calc(100%-48px)] [box-shadow:0px_4px_20px_0px_rgba(0_0_0/.05)]' : ''
      }`}
    >
      {hasIcon && <InfoSVGIcon className="info-svg min-w-4" />}
      <div className="text break-words [inline-size:calc(100%-32px)]">
        <h4 className="mb-1 text-gray-1">{title}</h4>
        {smallCaption && (
          <div className="small-caption-text text-gray-3">{smallCaption}</div>
        )}
        {hasErrorItems ? (
          <ErrorItemComponent errorItems={errorItems} />
        ) : null}
      </div>
    </div>
  )
}

const ErrorItemComponent = ({
  errorItems,
}: {
  errorItems: ErrorItem[];
}) => {
  if (errorItems.length === 1) {
    return (
      <div className="small-caption-text text-gray-3" style={{ marginTop: '8px' }}>
        {errorItems[0].message}
      </div>
    )
  }

  return (
    <ul
      className="small-caption-text list-disc text-gray-3"
      style={{ marginTop: '8px', paddingLeft: '20px' }}
    >
      {errorItems.map((item, index) => (
        <li key={item.key || index}>
          {item.message}
        </li>
      ))}
    </ul>
  )
}

export default Callout
